import {useState, ReactNode} from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  Box,
} from '@mui/material';
import {DEPLOYMENT_ENV} from '../constants';

const BETA_PASSWORD = process.env.REACT_APP_BETA_PASSWORD || '';
const STORAGE_KEY = 'beta-access';

const BetaRibbon = () => (
  <Box
    sx={{
      position: 'fixed',
      top: 12,
      right: -34,
      transform: 'rotate(45deg)',
      backgroundColor: '#ff5722',
      color: '#fff',
      fontSize: 11,
      fontWeight: 700,
      letterSpacing: 1,
      padding: '2px 40px',
      zIndex: 9999,
      pointerEvents: 'none',
      boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
    }}>
    BETA
  </Box>
);

interface BetaGateProps {
  children: ReactNode;
}

const BetaGate = ({children}: BetaGateProps) => {
  const [granted, setGranted] = useState(
    () => localStorage.getItem(STORAGE_KEY) === 'granted',
  );
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  if (DEPLOYMENT_ENV !== 'beta') {
    return <>{children}</>;
  }

  if (granted) {
    return (
      <>
        <BetaRibbon />
        {children}
      </>
    );
  }

  const handleSubmit = () => {
    if (password === BETA_PASSWORD) {
      localStorage.setItem(STORAGE_KEY, 'granted');
      setGranted(true);
      setError(false);
    } else {
      setError(true);
    }
  };

  return (
    <Dialog open fullWidth maxWidth="xs">
      <DialogTitle>Beta Access</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{mb: 2}}>
          This is the Bidmii beta environment. Enter the password to continue.
        </Typography>
        <TextField
          autoFocus
          fullWidth
          type="password"
          label="Password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            setError(false);
          }}
          onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
          error={error}
          helperText={error ? 'Incorrect password' : ''}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSubmit} variant="contained">
          Enter
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BetaGate;
